import {useEffect, useState} from "react";
import val_api from "../../api/valuation";

const CancellationReasonDialog = (props) => {
    const onConfirm = props.onConfirm;
    const onCancel = props.onCancel;

    const [groups, setGroups] = useState([]);
    const [groupId, setGroupId] = useState("");
    const [reasonId, setReasonId] = useState("");
    const [loadFailed, setLoadFailed] = useState(false);

    useEffect(() => {
        val_api.getCancellationReasons().then(response => {
            setGroups(response.data.groups || []);
        }).catch(err => {
            console.log(err);
            setLoadFailed(true);
        });
    }, []);

    const selectedGroup = groups.find(g => String(g.id) === String(groupId));
    const reasons = selectedGroup ? selectedGroup.reasons : [];
    const canConfirm = groupId !== "" && reasonId !== "";

    const handleGroupChange = (ev) => {
        setGroupId(ev.target.value);
        setReasonId("");
    };

    const handleConfirm = () => {
        if (!canConfirm) return;
        onConfirm(parseInt(reasonId));
    };

    return (
        <>
            <div className="page-mask low" onClick={onCancel}/>
            <div className="transfer-dialog-container fixed">
                <div className="transfer-dialog-title">Reject valuation</div>
                <div className="transfer-dialog-description">
                    Select who is cancelling the request and the reason before rejecting.
                </div>
                <div className="transfer-dialog-fields-container">
                    <div className="transfer-dialog-value">Cancelled by</div>
                    <div className="transfer-dialog-dropdown padded-arrow">
                        <select value={groupId} onChange={handleGroupChange}>
                            <option value="" disabled hidden>Select who cancelled</option>
                            {groups.map(g => (
                                <option value={g.id} key={g.id}>{g.name}</option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="transfer-dialog-fields-container">
                    <div className="transfer-dialog-value">Reason</div>
                    <div className="transfer-dialog-dropdown padded-arrow">
                        <select value={reasonId} onChange={(ev) => setReasonId(ev.target.value)}
                                disabled={groupId === ""}>
                            <option value="" disabled hidden>Select reason</option>
                            {reasons.map(r => (
                                <option value={r.id} key={r.id}>{r.name}</option>
                            ))}
                        </select>
                    </div>
                </div>
                {loadFailed
                    ? <div className="transfer-dialog-description">Failed to load cancellation reasons</div>
                    : null}
                <div className="transfer-dialog-footer-container">
                    <div className="transfer-dialog-button cancel link" onClick={onCancel}>
                        <div className="dialog-button-text">Cancel</div>
                    </div>
                    <div className={canConfirm ? "transfer-dialog-button link" : "transfer-dialog-button disabled"}
                         onClick={handleConfirm}>
                        <div className="dialog-button-text">Reject</div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CancellationReasonDialog;
